import axios from "axios";

import * as actionTypes from "./actionTypes";

export const initGetChat = () => {
  return {
    type: actionTypes.INIT_GET_CHAT,
    loading: true,
  };
};
export const initUpdateChat = () => {
  return {
    type: actionTypes.INIT_UPDATE_CHAT,
    updating: true,
  };
};
export const successGetChat = (data, ignoreHolding) => {
  return {
    type: actionTypes.SUCCESS_GET_CHAT,
    loading: false,
    chat: data.data,
    pagination_info: data.pagination_info,
    ignoreHolding: ignoreHolding,
    updating: false,
  };
};
const failGetChat = (error) => {
  return {
    type: actionTypes.FAIL_GET_CHAT,
    loading: false,
    error: error,
  };
};

export const getChat = (chatId, chat_page = "1", ignoreHolding) => {
  const token = localStorage.getItem("idToken");

  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };

  return (dispatch) => {
    if (ignoreHolding) dispatch(initUpdateChat());
    axios
      .get(`chats/${chatId}?chats_per_page=20&chat_page=${chat_page}`, config)
      .then((response) =>
        dispatch(successGetChat(response.data, ignoreHolding))
      )
      .catch((error) => dispatch(failGetChat(error.message)));
  };
};

// post message

export const setHoldPulling = (hold) => {
  return {
    type: actionTypes.HOLD_PULLING,
    holdPulling: hold,
  };
};

export const postMessage = (message, particpatntId, chatId, media) => {
  const token = localStorage.getItem("idToken");

  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };

  const data = {
    message: message,
    receiver_id: particpatntId,
  };

  if (media) data.media = media;

  return (dispatch) => {
    dispatch(setHoldPulling(true));
    axios
      .post("chat_messages", data, config)
      .then((response) => {
        dispatch(getChat(chatId));
        dispatch(setHoldPulling(false));
      })
      .catch((error) => console.log(error.message));
  };
};

export const setMessagesAsRead = (chatMessages, userId) => {
  const token = localStorage.getItem("idToken");

  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };

  let idsArray = [];

  chatMessages.forEach((mess) => {
    const id = mess.id;
    if (`${id}`.startsWith("HN")) {
      idsArray = [];
    } else {
      if (mess.user_id !== userId && !mess.read_at) {
        idsArray.push(id);
      }
    }
  });

  const setAsReadData = {
    ids: idsArray,
  };

  return (dispatch) => {
    if (idsArray.length !== 0) {
      axios
        .post("chat_messages/set_as_read", setAsReadData, config)
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error.message);
        });
    }
  };
};
